<div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
>
    <div>
        <table class="simple">
            <thead>
                <tr>
                    <th>#</th>
                    <th>
                        Especialidades
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() && !eliminado
                            "
                            mat-icon-button
                            color="accent"
                            (click)="agregarEspecialidad()"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </th>
                    <th class="text-right"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let especialidad of especialidades; let idx = index"
                >
                    <td>{{ idx + 1 }}</td>
                    <td>
                        <span class="text-bold">{{
                            especialidad.descripcion
                        }}</span>
                    </td>
                    <td>
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() && !eliminado
                            "
                            mat-icon-button
                            color="warn"
                            (click)="eliminar(especialidad)"
                        >
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="especialidades.length === 0">
            Sin especialidades por el momento
        </p>
    </div>
</div>
